<script lang="ts">
	import {
		AUTOSWAP_OP,
		AUTOSWAP_STABLES,
		AUTOWITHDRAW_MARGIN_FROM_CLOSEPOSITION
	} from '$lib/settings';

	export let size: string = 'sm';
</script>

<div class="mb-1">
	<div class="flex gap-2">
		<div class={`text-fx-grey-300 text-${size} w-full`}>
			Auto withdraw margin from markets without positions or orders for new trades.
		</div>
		<div
			class="border border-fx-grey-500 rounded-md bg-fx-grey-800 w-5 h-5 cursor-pointer flex items-center justify-center"
		>
			<input
				bind:checked={$AUTOWITHDRAW_MARGIN_FROM_CLOSEPOSITION}
				type="checkbox"
				class="checked:bg-fx-gradient-14 appearance-none w-2.5 h-2.5 rounded-sm cursor-pointer"
			/>
		</div>
	</div>
</div>

<div class="mb-1">
	<div class="flex gap-2">
		<div class={`text-fx-grey-300 text-${size} w-full`}>Auto swap stables during trading</div>
		<div
			class="border border-fx-grey-500 rounded-md bg-fx-grey-800 w-5 h-5 cursor-pointer flex items-center justify-center"
		>
			<input
				bind:checked={$AUTOSWAP_STABLES}
				type="checkbox"
				class="checked:bg-fx-gradient-14 appearance-none w-2.5 h-2.5 rounded-sm cursor-pointer"
			/>
		</div>
	</div>
</div>

<div class="mb-1">
	<div class="flex gap-2">
		<div class={`text-fx-grey-300 text-${size} w-full`}>Auto swap Non stables during trading</div>
		<div
			class="border border-fx-grey-500 rounded-md bg-fx-grey-800 w-5 h-5 cursor-pointer flex items-center justify-center"
		>
			<input
				bind:checked={$AUTOSWAP_OP}
				type="checkbox"
				class="checked:bg-fx-gradient-14 appearance-none w-2.5 h-2.5 rounded-sm cursor-pointer"
			/>
		</div>
	</div>
</div>
